// Configuración para Microsoft Authentication Library (MSAL)
// Los datos se obtienen desde el archivo .env

// Debug: Mostrar configuración actual
console.log("🔍 MSAL Debug - Variables de entorno:");
console.log("CLIENT_ID:", process.env.REACT_APP_MSAL_CLIENT_ID);
console.log("AUTHORITY:", process.env.REACT_APP_MSAL_AUTHORITY);
console.log("REDIRECT_URI:", process.env.REACT_APP_MSAL_REDIRECT_URI);
console.log("CURRENT_ORIGIN:", window.location.origin);

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID , // Application (client) ID de Azure Portal
    authority: process.env.REACT_APP_MSAL_AUTHORITY , // Authority URL completa
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI , // URI de redirección para desarrollo
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: console.error(message); break;
          case 1: console.warn(message); break;
          case 2: console.info(message); break;
          case 3: console.debug(message); break;
        }
      },
      logLevel: 2
    }
  }
};

// Scopes (permisos) que la aplicación necesita
export const loginRequest = {
  // Obtener los scopes desde las variables de entorno o usar un valor predeterminado
  scopes: process.env.REACT_APP_MSAL_SCOPES ? process.env.REACT_APP_MSAL_SCOPES.split(' ') : ["User.Read"],
  prompt: "select_account"
};

// Función para verificar si un usuario es administrador
// Debes personalizar esta función según tus necesidades
export const isUserAdmin = (account) => {
  // Verificar si el usuario tiene un correo específico o pertenece a un dominio específico
  if (account && account.username) {
    // Puedes personalizar esta lógica según tus necesidades
    // Por ejemplo:
    // 1. Verificar si el correo pertenece a un dominio específico
    // 2. Verificar si el correo está en una lista de administradores
    // 3. Verificar si el usuario tiene un rol específico en los claims del token
    
    // Ejemplo de implementación:
    const adminEmails = ['admin@example.com', 'director@example.com'];
    const adminDomains = ['admin.tudominio.com', 'sistemas.tudominio.com'];
    
    // Verificar si el email está en la lista de administradores
    if (adminEmails.includes(account.username.toLowerCase())) {
      return true;
    }
    
    // Verificar si el dominio del email está en la lista de dominios de administradores
    for (const domain of adminDomains) {
      if (account.username.toLowerCase().endsWith('@' + domain)) {
        return true;
      }
    }
    
    // También puedes verificar si el nombre de usuario contiene "admin"
    if (account.username.toLowerCase().includes('admin')) {
      return true;
    }
  }
  
  return false;
};